let measuringCanvas: HTMLCanvasElement | null = null

/** How wide `text` is drawn in `font` (a CSS font shorthand, e.g. "500 13px Inter"). */
export const textWidth = (text: string, font: string): number => {
  measuringCanvas ??= document.createElement('canvas')
  const context = measuringCanvas.getContext('2d')
  if (!context) return text.length * 7
  context.font = font
  return context.measureText(text).width
}
